import React, {useContext, useEffect} from 'react';
import { Box } from '@mui/material';
import {Navigate, Outlet} from 'react-router-dom';
import Sidebar from './sidebar';
import { styled } from '@mui/material/styles';
import { SidebarContext } from '../../contexts/SidebarContext';
import theme from "../../theme";
import {useAuth} from "../../contexts/AuthenticationContext";
import routes from "../../routes";
import {history} from "../../app";

interface MainWrapperProps {
    open: boolean;
}

const MainWrapper = styled(Box, {
    shouldForwardProp: prop => prop !== 'open',
})<MainWrapperProps>(({ open }) => ({
    flex: '1 1 auto',
    display: 'flex',
    height: '100%',
    paddingLeft: '57px',
    ...(!open && {
        [theme.breakpoints.up('sm')]: {
            paddingLeft: '73px',
        }
    }),
    ...(open && {
        paddingLeft: '225px',
    }),
}));

export default function DashboardLayout() {
    const { sidebarToggle } = useContext(SidebarContext);
    const { isAuthenticated, verifyAuthentication, verifyAuthenticationOnFirstLoad } = useAuth();

    useEffect(() => {
        verifyAuthenticationOnFirstLoad();

        return history.listen(() => {
            verifyAuthentication();
        });
    }, [isAuthenticated]);

    if (!isAuthenticated()) {
        return <Navigate to={routes.LOGIN} />;
    }

    return (
        <>
            <Sidebar />
            <MainWrapper open={sidebarToggle}>
                <Box sx={{ flex: '1 1 auto', overflow: 'auto' }}>
                    <Outlet />
                </Box>
            </MainWrapper>
        </>
    );
}
